import type * as React from 'react';
import { cn } from '@/lib/utils';

export interface SliderProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'value'> {
  value?: number[];
  onValueChange?: (value: number[]) => void;
  min?: number;
  max?: number;
  step?: number;
}

export function Slider({
  className,
  value,
  onValueChange,
  min = 0,
  max = 100,
  step = 1,
  ...props
}: SliderProps) {
  const currentValue = value?.[0] ?? min;

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    onValueChange?.([Number(e.target.value)]);
  }

  return (
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      value={currentValue}
      onChange={handleChange}
      className={cn(
        'h-2 w-full cursor-pointer appearance-none rounded-lg bg-ndd-800 accent-ndd-500',
        className
      )}
      {...props}
    />
  );
}
